module.exports = __webpack_public_path__ + "static/backgroundfull-a2c645cb12cfc135a2d1827d8d50e07d.png";